<script>
export default {
  name: 'PageActionBar',
  props: {
    primaryActions: {
      type: Array,
      default: () => [],
      validator: (actions) =>
        actions.every(a => typeof a.label === 'string' && typeof a.onClick === 'function')
    },
    secondaryActions: {
      type: Array,
      default: () => [],
      validator: (actions) =>
        actions.every(a => typeof a.label === 'string' && typeof a.onClick === 'function')
    }
  },
  computed: {
    visiblePrimary() {
      return this.primaryActions.filter(a => a.visible !== false)
    },
    visibleSecondary() {
      return this.secondaryActions.filter(a => a.visible !== false)
    }
  }
}
</script>

<template>
  <div class="d-flex flex-wrap gap-2 align-items-center mb-3">

    <!-- Primários: sempre visíveis -->
    <b-button
      v-for="(action, i) in visiblePrimary"
      :key="`primary-${i}`"
      :variant="action.variant || 'outline-primary'"
      :disabled="!!action.disabled"
      @click="action.onClick"
    >
      <i v-if="action.icon" :class="`${action.icon} font-size-16 align-middle me-2`"></i>
      {{ action.label }}
    </b-button>

    <!-- Secundários desktop (≥576px): inline -->
    <template v-if="visibleSecondary.length > 0">
      <b-button
        v-for="(action, i) in visibleSecondary"
        :key="`sec-${i}`"
        class="d-none d-sm-inline-flex align-items-center"
        :variant="action.variant || 'outline-secondary'"
        :disabled="!!action.disabled"
        @click="action.onClick"
      >
        <i v-if="action.icon" :class="`${action.icon} font-size-16 align-middle me-2`"></i>
        {{ action.label }}
      </b-button>

      <!-- Secundários mobile (<576px): dropdown -->
      <b-dropdown
        class="d-sm-none"
        variant="light"
        right
        no-caret
        menu-class="dropdown-menu-end"
      >
        <template #button-content>
          <i class="mdi mdi-dots-vertical me-1"></i>
          Mais Ações
        </template>
        <b-dropdown-item
          v-for="(action, i) in visibleSecondary"
          :key="`dd-${i}`"
          :disabled="!!action.disabled"
          @click="action.onClick"
        >
          <i v-if="action.icon" :class="`${action.icon} me-2`"></i>
          {{ action.label }}
        </b-dropdown-item>
      </b-dropdown>
    </template>

    <!-- Slot para conteúdo extra (ex: texto de status, switch) -->
    <div v-if="$slots.extra" class="flex-grow-1 ms-1">
      <slot name="extra" />
    </div>

  </div>
</template>
